import React from 'react';
import { Provider } from 'react-redux';
import store from '../../state';

import SkillEditTable from './SkillEditTable';

const SkillEditTableStandalone = props => (
  <Provider store={store}>
    <SkillEditTable {...props} />
  </Provider>
);

export default SkillEditTableStandalone;
